import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ServicePackage from "../../../components/servicePackage";
import { styles } from "./styles";
import Header from "../../../partials/header";

class Service extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    const { classes, t, ...props } = this.props;
    return (
      <>
        {/* <HeaderAdmin {...props} /> */}

        <Header session={t("Admin")} title={t("Package management")} />
        <ServicePackage {...props} />
      </>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  getServiceByCode: dispatch.service.getServiceByCode,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
